import React from 'react';

import Loader from "../common/Loader";
import l10n from "../../l10n/localization";
import * as ajaxRoutes from "../../constants/ajaxRoutes";
import * as authHandler from "../../utils/authHandler";

export default class CargoSummary extends React.Component {
    constructor(props) {
        super(props);

        this.state = {fogId: props.fogId, ...this.getValues()};
    }

    fetchValues() {
        let url = ajaxRoutes.API_ROUTE + "/fog/overall/"+this.state.fogId;
        let headers = new Headers({"X-Authorization": 'Bearer ' + authHandler.getToken()});

        fetch(url, {headers: headers})
            .then((response) => {
                if (response.ok) {
                    return response.json();
                }

                return response.json().then(json => {
                    return new Error(json.message || response.statusText)
                });
            })
            .then((data) => {
                this.setState({
                    value: parseFloat(data.value),
                    outturnSum: parseFloat(data.outturn),
                    shortageSum: parseFloat(data.shortage_gain),
                    quantity: parseFloat(data.total_quantity),
                    shortagePercent: parseFloat(data.shortage_pct),
                }, function() {
                    console.log(this.state)
                })
            })
            .catch((error) => {
                console.log("JMA")
                console.log(error)
            });
    }

    componentDidMount() {
        this.fetchValues();
    }


    getValues() {
        let value = 0;
        let outturnSum = 0;
        let shortageSum = 0;
        let quantity = 0;
        let shortagePercent = 0;

        for (let i = 0; i < this.props.cargoes.length; i++) {
            value += this.props.cargoes[i].value;
            outturnSum += this.props.cargoes[i].outturnTonnes;
            shortageSum += this.props.cargoes[i].quantity - this.props.cargoes[i].outturnTonnes;
            quantity += this.props.cargoes[i].quantity;
        }

        /*
        if (quantity > 0) {
            shortagePercent = shortageSum / quantity * 100;
            shortagePercent = 123456
        }
        */

        return {
            value: value,
            outturnSum: outturnSum,
            shortageSum: shortageSum,
            quantity: quantity,
            shortagePercent: shortagePercent,
        };
    }

    render() {
        if (this.props.loading || this.props.cargoes === undefined) {
            return (<div><Loader/></div>)
        }

        return (
            <div>
                <table className="cargo-summary">
                    <thead>
                    <tr>
                        <td>
                            {l10n.cargoSummary.outturn}
                        </td>
                        <td>
                            {l10n.cargoSummary.value}
                        </td>
                        <td>
                            {l10n.cargoSummary.shortage_gain}
                        </td>
                        <td>
                            {l10n.cargoSummary.shortage_percent}
                        </td>
                        <td>
                            {l10n.cargoSummary.totalQuantity}
                        </td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>
                            {!isNaN(this.state.outturnSum) && this.state.outturnSum.toLocaleString('en-US').replace(/,/g, " ")}
                        </td>
                        <td>
                            {!isNaN(this.state.value) && this.state.value.toLocaleString('en-US').replace(/,/g, " ")}
                        </td>
                        <td>
                            {!isNaN(this.state.shortageSum) && this.state.shortageSum.toLocaleString('en-US').replace(/,/g, " ")}
                        </td>
                        <td>
                            {!isNaN(this.state.shortagePercent) && this.state.shortagePercent.toLocaleString('en-US').replace(/,/g, " ")}
                        </td>
                        <td>
                            {!isNaN(this.state.quantity) && this.state.quantity.toLocaleString('en-US').replace(/,/g, " ")}
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/cargo/CargoSummary.js